import { IDictionary } from '@bimser/core';
import { dateRangePickerFormatter } from '../columnFormatters';
import { CustomizedDxColumn } from './generateColumns';

function calculateCellValue(this: CustomizedDxColumn, row: IDictionary<any>) {
	if (row[this.dataField]) {
		return dateRangePickerFormatter.call(
			this.retrieveDataGridInstance().__getBCColumn(this.dataField),
			row[this.dataField]
		);
	}
}

export const setDateRangePicker = (dxColumn: CustomizedDxColumn) => {
	dxColumn.calculateCellValue = calculateCellValue;
};
